module.exports = __webpack_public_path__ + "4f0c9e5e9a8e17fbcb2037f7b0cb754e.png";